'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
function $is_Lcom_raquo_laminar_modifiers_Modifier(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.n.ab)));
}
export { $is_Lcom_raquo_laminar_modifiers_Modifier as $is_Lcom_raquo_laminar_modifiers_Modifier };
function $isArrayOf_Lcom_raquo_laminar_modifiers_Modifier(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ab)));
}
export { $isArrayOf_Lcom_raquo_laminar_modifiers_Modifier as $isArrayOf_Lcom_raquo_laminar_modifiers_Modifier };
var $d_Lcom_raquo_laminar_modifiers_Modifier = new $j_java$002elang$002e$002dObject.$TypeData().i(1, "com.raquo.laminar.modifiers.Modifier", ({
  ab: 1
}));
export { $d_Lcom_raquo_laminar_modifiers_Modifier as $d_Lcom_raquo_laminar_modifiers_Modifier };
